import React from "react";

import "./kupu.css";

const setFontSize = (str, sz1, sz2, sz3) => {
  const length = str !== undefined ? str.length : 10;

  if (length < 15) {
    return { fontSize: sz1 };
  } else if (length >= 15) {
    return { fontSize: sz3 };
  }
};

const Kupu = props => {
  return (
    <div className="kupu-wrapper">
      <div className="kupu-container">
        <div className="item-kupu-maori">
          <p
            style={setFontSize(props.node.kupuMaori, "60px", "50px", "50px")}
            className="kupu-maori"
          >
            {props.node.kupuMaori}
          </p>
        </div>
        <div className="item-kupu-english">
          <p
            style={setFontSize(props.node.kupuEnglish, "60px", "50px", "50px")}
            className="kupu-english"
          >
            {props.node.kupuEnglish}
          </p>
        </div>
        <div className="item-divider">
          <div className="divider"></div>
        </div>
        <div className="item-term-maori">
          <p
            style={setFontSize(props.node.termMaori, "40px", "35px", "35px")}
            className="term-maori"
          >
            {props.node.termMaori}
          </p>
        </div>
        <div className="item-term-english">
          <p
            style={setFontSize(props.node.termEnglish, "40px", "35px", "35px")}
            className="term-english"
          >
            {props.node.termEnglish}
          </p>
        </div>
      </div>

      <div className="kupu-container-mobile">
        <div className="item-mobile">
          <p className="kupu-maori-mobile">{props.node.kupuMaori}</p>
        </div>
        <div className="item-mobile">
          <p className="kupu-english-mobile">{props.node.kupuEnglish}</p>
        </div>
        <div className="item-divider-mobile">
          <div className="divider-mobile"></div>
        </div>
        <div className="item-mobile">
          <p className="term-maori-mobile">{props.node.termMaori}</p>
        </div>
        <div className="item-mobile">
          <p className="term-english-mobile">{props.node.termEnglish}</p>
        </div>
      </div>
    </div>
  );
};

export default Kupu;
